import ConfirmationModal from 'components/modals/confirmation/ConfirmationModal';
import { FormattedMessage } from 'react-intl';

export function CaseStillConfidentialModal({ onCancel, onConfirm }: { onCancel: () => void; onConfirm: () => void }) {
    return (
        <ConfirmationModal
            titleId="case-closing-confidentiality.still-confidential-title"
            confirmId="case-closing-confidentiality.close-and-keep-confidential"
            cancelId="cancel"
            content={
                <p className="text-body1">
                    <FormattedMessage id="case-closing-confidentiality.still-confidential-text" />
                </p>
            }
            onCancel={onCancel}
            onConfirm={onConfirm}
        />
    );
}
